import { CircleQuestionMark } from 'lucide-preact';
import { ComponentProps } from 'preact';
import { useDispatch } from 'react-redux';

import { cn } from '@/lib/utils';

import { setProductsPromptModalState } from './ProductsPromptModal/redux/actions';

interface ProductFAQButtonProps extends Omit<ComponentProps<'a'>, 'href' | 'children'> {}

const ProductFAQButton = ({ className, onClick, ...props }: ProductFAQButtonProps) => {
  const dispatch = useDispatch();
  return (
    <a
      href="/help?tab=plans"
      className={cn('preflight preflight-a inline-block leading-none', className)}
      onClick={(e) => {
        dispatch(setProductsPromptModalState(null));
        onClick?.(e);
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <CircleQuestionMark className="size-5" />
      <span className="sr-only">FAQs</span>
    </a>
  );
};

export default ProductFAQButton;
